import { createAsyncThunk } from '@reduxjs/toolkit';

import { AuthService } from '@/Module/Auth/Service';

export const authSendVerificationCodeAction = createAsyncThunk<boolean, string>(
  'auth/sendVerificationCode',
  (phoneNumber, { signal }) => {
    return AuthService.sendVerificationCode({ phoneNumber }, signal).then(() => true);
  },
);
